import { createSlice } from '@reduxjs/toolkit'

export interface PresenterType {
  image: string
  name: string
  designationHtml: string
  descriptionHtml: string
}
export interface LiveSessionType {
  id: number
  title: string;
  date: string
  day: string
  startTime: string
  endTime: string
  description: string
  thumbnail?: string
  onDemandThumbnail?: string
  category:
    | 'Keynote'
    | 'Masterclass'
    | 'Free For All'
    | 'Others'
    | 'Special Presentation'
  presenters: Array<PresenterType>
  calendar: {
    google: string
    ics: string
    office365: string
    outlook: string
    yahoo: string
  }
  hasAccess: boolean
  durationInSeconds: number
  secondsTillStart: number
}

export interface LiveSessionsState {
  hasFetched: boolean
  isLoading: boolean
  liveSessions: Array<LiveSessionType>
}

const initialState: LiveSessionsState = {
  hasFetched: false,
  isLoading: false,
  liveSessions: [],
}

export const liveSessionsSlice = createSlice({
  name: 'liveSessions',
  initialState,
  reducers: {
    fetchLiveSessions: (state) => {
      state.isLoading = true
    },
    setLiveSessions: (state, action) => {
      state.liveSessions = action.payload
      state.isLoading = false
      state.hasFetched = true
    },
  },
})

export const { fetchLiveSessions, setLiveSessions } = liveSessionsSlice.actions

export default liveSessionsSlice.reducer
